/* eslint-disable */
export default {
  data() {
    return {
      // 现场监控层类型
      onSiteMonitoringTypeOptions: [
        {
          label: 'SUPCON ECS-700',
          value: 'SUPCON ECS-700'
        },
        {
          label: 'SUPCON JX-300XP',
          value: 'SUPCON JX-300XP'
        },
        {
          label: 'SUPCON GCS-G5/G3',
          value: 'SUPCON GCS-G5/G3'
        },
        {
          label: '通用DCS',
          value: '通用DCS'
        },
        {
          label: '通用PLC',
          value: '通用PLC'
        },
        {
          label: '通用SIS',
          value: '通用SIS'
        }
      ],
      // 冗余
      redundancyOptions: [
        {
          label: '冗余',
          value: '冗余'
        },
        {
          label: '非冗余',
          value: '非冗余'
        }
      ],
      // 现场监控层状态
      onSiteMonitoringStatusOptions: [
        {
          label: '正常',
          value: '正常'
        },
        {
          label: '离线',
          value: '离线'
        },
        {
          label: '故障',
          value: '故障'
        }
      ],
      // 过程监控层类型
      processMonitoringTypeOptions: [
        {
          label: '工程师站',
          value: '工程师站'
        },
        {
          label: '操作站',
          value: '操作站'
        },
        {
          label: '数据站',
          value: '数据站'
        },
        {
          label: '通讯接口站',
          value: '通讯接口站'
        },
        {
          label: '应用服务器站',
          value: '应用服务器站'
        }
      ],
      // 过程监控层安全配置
      securityConfigurationOptions: [
        {
          label: '白名单软件',
          value: '白名单软件'
        },
        {
          label: '杀毒软件',
          value: '杀毒软件'
        },
        {
          label: '日志代理',
          value: '日志代理'
        },
        {
          label: '备份代理',
          value: '备份代理'
        },
        {
          label: '其他审计代理',
          value: '其他审计代理'
        }
      ],
      // booler
      boolerOptions: [
        {
          label: '是',
          value: true
        },
        {
          label: '否',
          value: false
        }
      ],
      // 边界防御设备
      borderDefenseEquipmentOptions: [
        {
          label: '工业防火墙',
          value: '工业防火墙'
        },
        {
          label: '网闸',
          value: '网闸'
        },
        {
          label: '其他',
          value: '其他'
        }
      ],
      // 安全管理区域类型
      securityManagementAreaTypeOptions: [
        {
          label: '日志审计',
          value: '日志审计'
        },
        {
          label: '流量审计',
          value: '流量审计'
        },
        {
          label: '入侵检测',
          value: '入侵检测'
        },
        {
          label: '备份恢复',
          value: '备份恢复'
        },
        {
          label: '网络运行监控',
          value: '网络运行监控'
        },
        {
          label: '管理终端',
          value: '管理终端'
        },
        {
          label: '防火墙',
          value: '防火墙'
        }
      ],
      // 生产管理网边界防御措施类型
      defensiveMeasuresTypeOptions: [
        {
          label: '防火墙',
          value: '防火墙'
        },
        {
          label: '网闸',
          value: '网闸'
        },
        {
          label: '安全网关',
          value: '安全网关'
        }
      ],
      // 生产管理层类型
      productionManagementTypeOptions: [
        {
          label: '接口机',
          value: '接口机'
        },
        {
          label: '实时数据库服务器',
          value: '实时数据库服务器'
        },
        {
          label: '关系数据库',
          value: '关系数据库'
        },
        {
          label: 'web服务器',
          value: 'web服务器'
        },
        {
          label: '应用服务器',
          value: '应用服务器'
        }
      ],
      // 模块
      modularOptions: [
        {
          label: '用户资产清单',
          value: 1
        },
        {
          label: '通讯协议流量和类型统计',
          value: 2
        },
        {
          label: '告警类型分布',
          value: 3
        },
        {
          label: '安全事件分级统计',
          value: 4
        },
        {
          label: '重大操作',
          value: 5
        },
        {
          label: '恶意代码事件/恶意文件告警分析/webshell告警',
          value: 6
        },
        {
          label: '网络入侵提示',
          value: 7
        },
        {
          label: '事前通报预警',
          value: 8
        },
        {
          label: '事后工单/待办工单',
          value: 9
        },
        {
          label: '告警数量本周和本月统计',
          value: 10
        },
        {
          label: '安全事件趋势',
          value: 11
        },
        // {
        //   label: 'CPU/内存/带宽',
        //   value: 12
        // },
        {
          label: '网络整体安全状态评分',
          value: 12
        }
      ]
    }
  }
}
export const topologyArray = [
  {
    name: '现场监控层',
    code: '10',
    order: 4
  },
  {
    name: '过程监控层',
    code: '20',
    order: 3
  },
  {
    name: '安全管理区域',
    code: '30',
    order: 2
  },
  {
    name: '生产管理网边界防御措施',
    code: '40',
    order: 1
  },
  {
    name: '生产管理',
    code: '50',
    order: 0
  }
]
// 告警数量本周本月统计key对应汉字
export const constKey = {
  monthly: '本月统计',
  weekly: '本周统计',
  value: '告警数量',
  last: '上一维度告警数量',
  inc: '相对变化量',
  unprocessed: '未处理告警量',
  processed: '已处理告警量'
}
// 告警数量本周本月统计汉字对应显示顺序
export const constArryOrder = {
  '本周统计': 0,
  '本月统计': 1
}

// 告警数量本周本月统计汉字对应显示顺序
export const constChildArryOrder = {
  '告警数量': 0,
  '上一维度告警数量': 1,
  '相对变化量': 2,
  '未处理告警量': 3,
  '已处理告警量': 4
}
